// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"db20e603","796":"df2d6e4f"}[chunkId] + ".chunk.js";
};